/* global mixpanel */

export function createRole (data) {
  mixpanel.track('Create New Role', createAndEditDataToMixPanelData(data))
}

export function editRole (data) {
  mixpanel.track('Edit Role', createAndEditDataToMixPanelData(data))
}

export function deleteRole (data) {
  mixpanel.track('Delete Role', deleteDataToMixPanelData(data))
}

function deleteDataToMixPanelData (data) {
  let permissionAppSubMenu = []
  let backOfficeSubMenu = []

  for (let i = 0; i < data.permissions.length; i++) {
    let permission = data.permissions[i]
    if (permission.access === 'App') {
      permissionAppSubMenu.push(permission.sub_menu)
    } else if (permission.access === 'Back-office') {
      backOfficeSubMenu.push(getPermissionName(permission))
    }
  }

  return {
    'Role Name': data.name,
    'Access App': permissionAppSubMenu,
    'Access Back Office': backOfficeSubMenu
  }
}

function createAndEditDataToMixPanelData (data) {
  let permissionAppSubMenu = data.active_permissions_app
    ? data.active_permissions_app.map(permission => permission.sub_menu) : null

  let backOfficeSubMenu = data.active_permissions_backoffice
    ? data.active_permissions_backoffice.map(permission => getPermissionName(permission)) : null

  return {
    'Role Name': data.name,
    'Access App': permissionAppSubMenu,
    'Access Back Office': backOfficeSubMenu
  }
}

function getPermissionName (permission) {
  let name = permission.sub_menu
  if (name !== permission.menu) {
    name = `${permission.menu} - ${name}`
  }
  return name
}



// WEBPACK FOOTER //
// ./app/mixpanel/employees/role.js